const table = [
    {
        prop: 'Region',
        label: 'Región',
        minWidth: 100
    },
    {
        prop: 'Depart_Code',
        label: 'Cod. Dpto.',
        minWidth: 100
    },    
    {
        prop: 'Depart_Nombre',
        label: 'Departamento',
        minWidth: 150
    },
    {
        prop: 'Municipio_Code',
        label: 'Cod. Munic.',
        minWidth: 100
    },    
    {
        prop: 'name',
        label: 'Municipio',
        minWidth: 150
    },
    {
        prop: 'IDPunto',
        label: 'ID Punto',
        minWidth: 150
    },
    {
        prop: 'Cedula',
        label: 'Cédula',
        minWidth: 100
    },
    {
        prop: 'NombreCliente',
        label: 'Cliente',
        minWidth: 150
    },
    {
        prop: 'FechaInstalad',
        label: 'Fecha de Instalación',
        minWidth: 150
    }
]

const table_plus = [
    {
        prop: "Barrio",
        label: "Barrio", 
    },
    {
        prop: "Direccion",
        label: "Diección", 
    },
    {
        prop: "Estrato",
        label: "Estrato", 
    },
    {
        prop: "Dificultades_Acceso",
        label: "Dificultad Acceso", 
    },
    {
        prop: "Etnia",
        label: "Etnia", 
    },
    {
        prop: "Genero",
        label: "Género", 
    },
    {
        prop: "OrientSexual",
        label: "Orientación Sexual", 
    },
    {
        prop: "Sexo",
        label: "Sexo", 
    },
    {
        prop: "NivelEducativo",
        label: "Nivel Educativo", 
    },
    {
        prop: "Discapacidad",
        label: "Discapacidad", 
    },
    {
        prop: "AnexContrato",
        label: "Anexo Contrato", 
    },
    {
        prop: "AnexCC",
        label: "Anexo Cedula", 
    },
    {
        prop: "AnexDeclaracion",
        label: "Anexo Declaración", 
    },
    {
        prop: "AnexSP",
        label: "Anexo SP", 
    },
    {
        prop: "SISBEN",
        label: "Anexo SISBEN", 
    },
    {
        prop: "AnexPR",
        label: "Anexo PR", 
    },
    {
        prop: "AnexLey1699",
        label: "Anexo Ley 1699", 
    },
    {
        prop: "AnexTestVelocidad",
        label: "Anexo Test de Velocidad", 
    },
  ]

export default [table, table_plus]
